<template>
    <kt-row v-if="status === 'setFormData'">
        <kt-col xs="12">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;"
                 v-if="gateway.status != gatewayStatus.PENDING &&
                 gateway.status != gatewayStatus.SEND_TO_SHAPARAK &&
                 gateway.has_terminal_model"
            >
                <kt-form-section>
                    <div class="section-header">
                        {{ $t('label.terminals') }}
                    </div>
                    <kt-form-group>
                        <kt-row class="mb-3 pl-3" v-for="(value, psp) in gateway.terminals" :key="psp">
                            <kt-col lg="12" md="12" xs="12">
                                <div class="custom-control custom-switch">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'psp_title_'+ psp"
                                            :name="'psp_title_'+ psp"
                                            v-model="gateway.terminals[psp]"
                                            :disabled="true"
                                    >
                                    <label class="custom-control-label" :for="'psp_title_'+ psp">
                                        {{ $t('psp.' + psp) }}
                                    </label>

                                    <div class="d-inline"
                                         v-if="gateway.active_terminals[psp]">
                                        <button
                                                :title="$t('label.change_gateway_details') + ' ' + $t('psp.' + psp)"
                                                class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                                type="button"
                                                :disabled="psp === 'asanpardakht'"
                                                data-toggle="modal"
                                                :data-target="'#gateway-change-detail-modal-'+psp"
                                                :id="'change_gateway_change_detail_btn'+psp"
                                                style="float: left"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <!-- Modal -->
                                        <div :id="'gateway-change-detail-modal-'+psp"
                                             class="modal fade" role="dialog">
                                            <div class="modal-dialog">
                                                <!-- Modal content-->
                                                <div class="modal-content" id="user-access-modal-content">
                                                    <div class="modal-header">
                                                        <h4 class="modal-title">
                                                            {{ $t('label.change_gateway_details') + ' ' + $t('psp.' + psp) }}
                                                        </h4>
                                                        <button type="button" class="close" data-dismiss="modal">&times;
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <p>{{ $t('label.change_gateway_details') }}</p>
                                                        <kt-form-section>
                                                            <kt-row class="mb-3">
                                                                <kt-col lg="12" md="12" xs="12">
                                                                    <div class="custom-control custom-checkbox"
                                                                         :id="`logo-div-${psp}`">
                                                                        <input
                                                                                type="checkbox"
                                                                                class="custom-control-input"
                                                                                :id="`change_logo-${psp}`"
                                                                                :name="`change_logo-${psp}`"
                                                                        >
                                                                        <label class="custom-control-label"
                                                                               :for="`change_logo-${psp}`">
                                                                            {{ $t('label.change_logo') }}
                                                                        </label>
                                                                    </div>
                                                                </kt-col>
                                                            </kt-row>
                                                            <kt-row class="mb-3">
                                                                <kt-col lg="12" md="12" xs="12">
                                                                    <div class="custom-control custom-checkbox"
                                                                         :id="`websiteAddress-div-${psp}`">
                                                                        <input
                                                                                type="checkbox"
                                                                                class="custom-control-input"
                                                                                :disabled="psp === 'irankish'"
                                                                                :id="`change_websiteAddress-${psp}`"
                                                                                :name="`change_websiteAddress-${psp}`"
                                                                        >
                                                                        <label class="custom-control-label"
                                                                               :for="`change_websiteAddress-${psp}`">
                                                                            {{ $t('label.change_websiteAddress') }}
                                                                        </label>
                                                                    </div>
                                                                </kt-col>
                                                            </kt-row>
                                                            <kt-row class="mb-3">
                                                                <kt-col lg="12" md="12" xs="12">
                                                                    <div class="custom-control custom-checkbox"
                                                                         :id="`gatewayName-div-${psp}`">
                                                                        <input
                                                                                type="checkbox"
                                                                                class="custom-control-input"
                                                                                :disabled="psp === 'irankish'"
                                                                                :id="`change_gatewayName-${psp}`"
                                                                                :name="`change_gatewayName-${psp}`"
                                                                        >
                                                                        <label class="custom-control-label"
                                                                               :for="`change_gatewayName-${psp}`">
                                                                            {{ $t('label.change_gatewayName') }}
                                                                        </label>
                                                                    </div>
                                                                </kt-col>
                                                            </kt-row>
                                                        </kt-form-section>
                                                        <kt-form-action class="mt-4">
                                                            <kt-button
                                                                    class="m-2 btn-wide"
                                                                    size="md"
                                                                    variant="primary"
                                                                    type="button"
                                                                    v-bind:wide="true"
                                                                    :id="`change_logo_btn${psp}`"
                                                                    :data-psp="psp"
                                                                    @click="changeLogo(psp)"
                                                            >
                                                                {{ $t('btn.submit') }}
                                                            </kt-button>
                                                        </kt-form-action>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <router-link
                                                class="btn btn-sm btn-clean btn-icon btn-icon-sm float-left"
                                                :title="$t('btn.getTransactionReport') + ' ' + $t('psp.' + psp)"
                                                :to="{name: 'transactions-report',params: {hashid: gateway.id}, query: {psp: psp}}"
                                                style="float: left!important;"
                                        >
                                            <i class="fa fa-chart-line"></i>
                                        </router-link>
                                        <router-link
                                                class="btn btn-sm btn-clean btn-icon btn-icon-sm float-left"
                                                :to="{name: 'statements-user',params: {hashid: gateway.id}, query: {psp: psp}}"
                                                :title="$t('btn.getStatementsReport') + ' ' + $t('psp.' + psp)"
                                                style="float: left!important;"
                                        >
                                            <i class="fa fa-database"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </kt-col>
                        </kt-row>
                        <kt-row class="mb-3 pl-3">
                            <kt-col lg="12" md="12" xs="12">
                                <div class="custom-control custom-switch">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="connect_to_collective"
                                            name="connect_to_collective"
                                            v-model="gateway.connect_to_collective"
                                            :disabled="true"
                                    >
                                    <label class="custom-control-label" for="connect_to_collective">
                                        {{ $t('psp.connect_to_collective') }}
                                    </label>
                                </div>
                            </kt-col>
                        </kt-row>
                    </kt-form-group>
                </kt-form-section>
            </div>
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;"
                 v-if="gateway.status != gatewayStatus.PENDING &&
                 gateway.status != gatewayStatus.SEND_TO_SHAPARAK &&
                 gateway.has_terminal_model"
            >
                <kt-form-section>
                    <div class="section-header">
                        {{ $t('label.shaparak_acceptors_status') }}
                    </div>
                    <kt-form-group>
                        <ul style="list-style-type: none; padding-inline-start: 0">
                            <kt-row class="mb-3 pl-3" v-for="(value, psp) in gateway.shaparak_acceptors_status" :key="psp">
                                <kt-col lg="12" md="12" xs="12">
                                    <li class="mt-3">
                                        <kt-row>
                                            <kt-col lg="6" md="6" sm="6">
                                                <span class="float-left pt-1">
                                                    {{ $t('psp.' + psp) }}
                                                </span>
                                            </kt-col>
                                            <kt-col lg="6" md="6" sm="6">
                                                <span class="float-right">
                                                    <div :class="'badge badge-'+ terminalStatusVariant(gateway.shaparak_acceptors_status[psp]) +' text-white'">
                                                        {{ terminalStatusStr(gateway.shaparak_acceptors_status[psp]) }}
                                                    </div>
                                                     <button href="#" @click.prevent="showEditTerminalStatusForm(psp)"
                                                             :title="$t('btn.edit')"
                                                             class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                                         <i class="fa fa-edit"></i>
                                                     </button>
                                                </span>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-if="edit_terminal_status === psp">
                                            <kt-col lg="9" md="9" sm="9">
                                                <kt-form-select
                                                        class="mt-3"
                                                        size="3"
                                                        :id="'edit_terminal_status_' + psp"
                                                        :name="'status_' + psp"
                                                        v-model="gateway.shaparak_acceptors_status[psp]"
                                                        @change="changeTerminalStatus(psp)"
                                                >
                                                    <option
                                                            v-bind:key="index"
                                                            v-for="(status, index) in terminal_statuses"
                                                            v-bind:value="status.value"
                                                            :selected="gateway.shaparak_acceptors_status[psp] == status.value"
                                                    >
                                                        {{ status.name }}
                                                    </option>
                                                </kt-form-select>
                                            </kt-col>
                                            <kt-col lg="3" md="3" sm="3">
                                                <a href="#" @click.prevent="submitTerminalStatusForm(psp)"
                                                   :title="$t('btn.submit')"
                                                   :id="'edit_terminal_status_btn_' + psp"
                                                   style="float: left; background: #1dc9b7; color: white"
                                                   class="btn btn-sm  btn-icon btn-icon-sm mt-3 mr-2">
                                                    <i class="fa fa-check"></i>
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </li>
                                </kt-col>
                            </kt-row>
                        </ul>
                    </kt-form-group>
                </kt-form-section>
            </div>
            <form @submit.prevent="transactionsReportSetting" id="transactions_report_form"
                  v-if="checkActivePsp && gateway.status == gatewayStatus.ACTIVE"
            >
                <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.transactions_report_settings') }}
                        </div>
                        <kt-form-group>
                            <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                                <div class="custom-control custom-checkbox" id="reports_setting-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="reports_setting"
                                            name="reports_setting"
                                            v-model="gateway.show_psp_report_to_user"
                                    >
                                    <label class="custom-control-label" id="reports_setting_label" for="reports_setting">
                                        {{ $t('label.showPSPReportToUser') }}
                                    </label>
                                </div>
                            </kt-row>
                            <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                                <div class="custom-control custom-checkbox" id="reports_setting-div_full">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="reports_setting_full"
                                            name="reports_setting_full"
                                            v-model="gateway.show_statement_report_to_user"
                                    >
                                    <label class="custom-control-label" id="reports_setting_label_full" for="reports_setting_full">
                                        {{ $t('label.showStatementReportToUser') }}
                                    </label>

                                </div>
                            </kt-row>
                        </kt-form-group>
                    </kt-form-section>
                    <kt-form-action class="mt-4">
                        <kt-row>
                            <kt-col xs="12" md="6">
                                <button
                                        class="btn btn-md btn-success btn-wide"
                                        type="submit"
                                        id="transactions_report_btn"
                                >
                                    {{ $t('btn.save') }}
                                </button>
                            </kt-col>
                        </kt-row>
                    </kt-form-action>
                </div>
            </form>
            <form @submit.prevent="edit" id="settings_form">
                <div class="container p-3 pt-5 my-4 border in-border-header">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.basic_settings') }}
                        </div>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.change_status') }}
                            </kt-form-label>
                            <kt-form-select
                                    v-if="gateway.can_be_sent_to_shaparak"
                                    size="3"
                                    id="status"
                                    name="status"
                                    v-model="gateway.status"
                            >
                                <option
                                        v-bind:key="index"
                                        v-for="(status, index) in statuses"
                                        v-bind:value="status.value"
                                        :selected="gateway.status === status.value"
                                >
                                    {{ status.name }}
                                </option>
                            </kt-form-select>
                            <kt-form-select v-else size="3" id="status" name="status" v-model="gateway.status">
                                <option
                                        v-bind:key="index"
                                        v-for="(status, index) in statuses_without_send_to_shaparak"
                                        v-bind:value="status.value"
                                        :selected="gateway.status === status.value"
                                >
                                    {{ status.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>

<!--                        <kt-form-group>-->
<!--                            <div class="custom-control custom-switch">-->
<!--                                <input type="checkbox" class="custom-control-input" id="psp_transactions_only" name="psp_transactions_only" v-model="gateway.psp_transactions_only">-->
<!--                                <label class="custom-control-label" for="psp_transactions_only">{{ $t('label.psp_transactions_only') }}</label>-->
<!--                            </div>-->
<!--                        </kt-form-group>-->

<!--                        <kt-form-group>-->
<!--                            <div class="custom-control custom-switch">-->
<!--                                <input type="checkbox" class="custom-control-input" id="partial_settlement" name="partial_settlement" v-model="gateway.partial_settlement">-->
<!--                                <label class="custom-control-label" for="partial_settlement">{{ $t('label.partial_settlement') }}</label>-->
<!--                            </div>-->
<!--                        </kt-form-group>-->

<!--                        <transition name="fade">-->
<!--                            <kt-form-group v-if="gateway.partial_settlement">-->
<!--                                <kt-form-label>-->
<!--                                    {{ $t('label.settlement_percent') }}-->
<!--                                </kt-form-label>-->
<!--                                <div class="kt-input-icon kt-input-icon&#45;&#45;left">-->
<!--                                    <kt-form-control-->
<!--                                            type="number"-->
<!--                                            min="1"-->
<!--                                            max="99"-->
<!--                                            dir="ltr"-->
<!--                                            id="settlement_percent"-->
<!--                                            name="settlement_percent"-->
<!--                                            v-model="gateway.settlement_percent"-->
<!--                                    >-->
<!--                                    </kt-form-control>-->
<!--                                    <span class="kt-input-icon__icon kt-input-icon__icon&#45;&#45;left">-->
<!--                                        <span>{{ $t('label.percent') }}</span>-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </kt-form-group>-->
<!--                        </transition>-->

<!--                        <kt-form-group>-->
<!--                            <div class="custom-control custom-switch">-->
<!--                                <input-->
<!--                                        type="checkbox"-->
<!--                                        class="custom-control-input"-->
<!--                                        id="wage_to_sheba"-->
<!--                                        name="wage_to_sheba"-->
<!--                                        v-model="gateway.wage_to_sheba"-->
<!--                                        @change="initChangeSwitch()"-->
<!--                                >-->
<!--                                <label class="custom-control-label" for="wage_to_sheba">{{ $t('label.wage_to_sheba') }}</label>-->
<!--                            </div>-->
<!--                        </kt-form-group>-->

<!--                        <transition name="fade">-->
<!--                            <kt-form-group v-if="gateway.wage_to_sheba">-->
<!--                                <kt-form-label>-->
<!--                                    {{ $t('label.sheba_number') }}-->
<!--                                </kt-form-label>-->
<!--                                <div class="kt-input-icon kt-input-icon&#45;&#45;right">-->
<!--                                    <kt-form-control-->
<!--                                            dir="ltr"-->
<!--                                            @focusin="initFocusInput()"-->
<!--                                            id="wage_sheba_number"-->
<!--                                            name="wage_sheba_number"-->
<!--                                            v-model="gateway.wage_sheba_number"-->
<!--                                    >-->
<!--                                    </kt-form-control>-->
<!--                                    <span class="kt-input-icon__icon kt-input-icon__icon&#45;&#45;right">-->
<!--                                        <span>IR</span>-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </kt-form-group>-->
<!--                        </transition>-->

                        <kt-form-group v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK">
                            <kt-form-label class="mb-3"> {{ $t('label.terminal_request') }}</kt-form-label>
                            <kt-row class="mb-3 pl-3" v-for="(value, psp) in gateway.terminals" :key="psp">
                                <kt-col lg="12" md="12" xs="12">
                                    <div class="custom-control custom-switch">
                                        <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                :id="'psp_'+ psp"
                                                :name="'psp_'+ psp"
                                                v-model="gateway.terminals[psp]"
                                                :disabled="gateway.has_terminal_model"
                                        >
                                        <label class="custom-control-label" :for="'psp_'+ psp">
                                            {{ $t('psp.' + psp) }}
                                        </label>
                                    </div>
                                </kt-col>
                            </kt-row>
                        </kt-form-group>

                        <kt-form-group v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK ||
                            gateway.status == gatewayStatus.ACTIVE"
                        >
                            <kt-form-label>
                                {{ $t('label.change_wage_type') }}
                            </kt-form-label>
                            <kt-form-select size="3" id="wage_type" name="wage_type" v-model="gateway.wage_type">
                                <option
                                        v-bind:key="index"
                                        v-for="(wage_type, index) in wage_types"
                                        v-bind:value="wage_type.value"
                                        :selected="wage_type.value"
                                >
                                    {{ wage_type.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>

                        <transition name="fade" v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK ||
                            gateway.status == gatewayStatus.ACTIVE"
                        >
                            <kt-form-group v-if="gateway.wage_type === 'PERIODIC'">
                                <kt-form-label>
                                    {{ $t('label.change_wage_period') }}
                                </kt-form-label>
                                <kt-form-select
                                        size="4"
                                        id="wage_periodic_type"
                                        name="wage_periodic_type"
                                        v-model="gateway.wage_periodic_type"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(wage_periodic_type, index) in wage_periodic_types"
                                            v-bind:value="wage_periodic_type.value"
                                            :selected="wage_periodic_type.value"
                                    >
                                        {{ wage_periodic_type.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </transition>
                        <transition name="fade" v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK ||
                            gateway.status == gatewayStatus.ACTIVE"
                        >
                            <kt-form-group>
                                <kt-form-label>
                                    {{
                                    (gateway.wage_type === 'PERCENT') ?
                                    $t('label.wage_amount_percent') :
                                    ((gateway.wage_type === 'FIXED') ?
                                    $t('label.wage_amount_fixed') :
                                    $t('label.wage_amount_periodic'))
                                    }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control dir="ltr" id="wage_amount" name="wage_amount"
                                                     v-model="gateway.wage_amount">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{
                                (gateway.wage_type === 'PERCENT') ?
                                    $t('label.percent'):
                                    $t('currency.rial')
                              }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade" v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK ||
                            gateway.status == gatewayStatus.ACTIVE"
                        >
                            <kt-form-group v-if="gateway.wage_type === 'PERCENT'">
                                <kt-form-label>
                                    {{ $t('label.min_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control dir="ltr"
                                                     id="wage_min_wage"
                                                     name="wage_min_wage"
                                                     v-model="gateway.wage_min_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                        <span>{{ $t('currency.rial') }}</span>
                                   </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade" v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK ||
                            gateway.status == gatewayStatus.ACTIVE"
                        >
                            <kt-form-group v-if="gateway.wage_type === 'PERCENT'">
                                <kt-form-label>
                                    {{ $t('label.max_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage"
                                                     v-model="gateway.wage_max_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>

                        <kt-form-action class="mt-4">
                            <kt-row>
                                <kt-col xs="12" md="6">
                                    <button class="btn btn-md btn-success btn-wide" type="submit"
                                            id="change_status_btn">
                                        {{ $t('btn.edit') }}
                                    </button>
                                </kt-col>
                                <kt-col xs="12" md="6" class="" dir="rtl">
                                    <router-link class="btn btn-dark" :to="{name: 'pardakht_shakhsi_details', params:{hashid: gateway.user.shakhsi_id}}"
                                    >{{$t('label.pardakht_shakhsi_setting')}}</router-link>
                                </kt-col>
                            </kt-row>

                        </kt-form-action>
                    </kt-form-section>
                </div>
            </form>
            <form @submit.prevent="saveLimitation" id="limitation_form"
                  v-if="gateway.status == gatewayStatus.SEND_TO_SHAPARAK || gateway.has_terminal_model"
            >
                <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.ip_limitation_settings') }}
                        </div>
                        <limitations :gateway="gateway"></limitations>
                    </kt-form-section>
                    <kt-form-action class="mt-4">
                        <kt-row>
                            <kt-col xs="12" md="6">
                                <button
                                        class="btn btn-md btn-success btn-wide"
                                        type="submit"
                                        id="save_limitation"
                                >
                                    {{ $t('btn.save') }}
                                </button>
                            </kt-col>
                        </kt-row>
                    </kt-form-action>
                </div>
            </form>
        </kt-col>
    </kt-row>
</template>

<script>
    import $ from 'jquery'
    import {KTApp} from '@/plugins/core/app'
    import {gatewayStatusStr, gatewayStatus, statuses} from '@/constants/gatewayStatus'
    import {terminalStatusStr, terminalStatus, statusVariant} from '@/constants/TerminalStatus'
    import {mapGetters} from 'vuex'
    import {gatewayService} from '@/common/api.service'
    import {i18n} from '@/plugins/i18n'
    import {KTUtil} from '@/plugins/core/util'
    import limitations from './limitations'
    import Inputmask from "inputmask";
    import toastr from "toastr";

    export default {
        computed: {
            ...mapGetters('gateway', {
                gateway: 'form_data',
                status: 'status'
            }),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false,
                    progressBar: true
                }
                return toastr
            },
            checkActivePsp() {
                let status;

                for (let item in this.gateway.terminals) {
                    if (this.gateway.terminals[item] === true) {
                        return status = true;
                    }
                }
                return status
            }
        },
        components: {
            'limitations': limitations,
        },
        watch: {
            'gateway.status'(newValue, oldValue) {
                console.log(newValue, oldValue)
                if (newValue === gatewayStatus.ACTIVE && oldValue === gatewayStatus.PENDING) {
                    this.has_collective = true;
                } else {
                    this.has_collective = false;
                }
                if (newValue == gatewayStatus.SEND_TO_SHAPARAK && !this.gateway.has_terminal_model) {
                    for (let item in this.gateway.terminals) {
                        this.gateway.terminals[item] = true;
                    }
                }
            },
        },
        data() {
            return {
                gatewayStatus,
                statuses: statuses,
                statuses_without_send_to_shaparak: [
                    {
                        name: gatewayStatusStr.ACTIVE,
                        value: gatewayStatus.ACTIVE
                    },
                    {
                        name: gatewayStatusStr.PENDING,
                        value: gatewayStatus.PENDING
                    },
                    {
                        name: gatewayStatusStr.REJECTED,
                        value: gatewayStatus.REJECTED
                    },
                    {
                        name: gatewayStatusStr.BLOCKED,
                        value: gatewayStatus.BLOCKED
                    },
                    {
                        name: gatewayStatusStr.REJECTED_BY_SHAPARAK,
                        value: gatewayStatus.REJECTED_BY_SHAPARAK
                    },
                    {
                        name: gatewayStatusStr.DIRECT_TO_PSP,
                        value: gatewayStatus.DIRECT_TO_PSP
                    },
                ],
                limits: [
                    {
                        name: this.$t('limit.limited'),
                        value: 1
                    },
                    {
                        name: this.$t('limit.unlimited'),
                        value: 0,
                    }
                ],
                wage_types: [
                    {
                        name: this.$t('gateway.wage_types.percent'),
                        value: 'PERCENT'
                    },
                    {
                        name: this.$t('gateway.wage_types.fixed'),
                        value: 'FIXED'
                    },
                    {
                        name: this.$t('gateway.wage_types.periodic'),
                        value: 'PERIODIC',
                    }
                ],
                wage_periodic_types: [
                    {
                        name: this.$t('gateway.wage_periodic_types.1'),
                        value: 1
                    },
                    {
                        name: this.$t('gateway.wage_periodic_types.3'),
                        value: 3
                    },
                    {
                        name: this.$t('gateway.wage_periodic_types.6'),
                        value: 6,
                    },
                    {
                        name: this.$t('gateway.wage_periodic_types.12'),
                        value: 12,
                    }
                ],
                edit_terminal_status : null,
                terminal_statuses: [
                    {
                        name: terminalStatusStr.INACTIVE,
                        value: terminalStatus.INACTIVE,
                    },
                    {
                        name: terminalStatusStr.ACTIVE,
                        value: terminalStatus.ACTIVE,
                    },
                    {
                        name: terminalStatusStr.BLOCKED_BY_SHAPARAK,
                        value: terminalStatus.BLOCKED_BY_SHAPARAK,
                    }
                ],
                change_terminal_status_processing: false,
                has_collective: false,
                is_starshop: this.$route.params.gateway_source === 'starshop-gateways',
            }
        },
        methods: {
            edit(e) {
                let btn = $('#change_status_btn')
                let form = $('#settings_form')
                KTApp.progress(btn)
                let is_failed = false

                if (
                    (this.gateway.status == gatewayStatus.SEND_TO_SHAPARAK || this.gateway.status == gatewayStatus.ACTIVE) &&
                    !this.gateway.has_terminal_model
                ) {
                    this.createTerminals(form, btn)
                } else {
                    KTApp.progress(btn)
                    this.changeStatus(form)
                    this.changeWage(form, btn)
                    this.changeSettlementSettings(form, btn)
                }
                this.$store.dispatch('badgeCounter/countData', this.is_starshop)
            },
            saveLimitation(e) {
                let btn = $('#save_limitation');
                let form = $('#limitation_form');

                form.validate({
                    rules: {
                        limit_amount: {
                            required: this.gateway.has_limit,
                            min: 1000,
                            digits: true
                        }
                    }
                })

                if (!form.valid()) {
                    return
                }

                KTApp.progress(btn);

                gatewayService.changeLimitation(this.gateway.id, {
                    has_limit: this.gateway.has_limit,
                    any_payment_limitation: this.gateway.any_payment_limitation,
                    callback_address_limitation: this.gateway.callback_address_limitation,
                    referer_limitation: this.gateway.referer_limitation,
                    server_ip_limitation: this.gateway.server_ip_limitation,
                    limit_amount: this.gateway.limit_amount,
                    abroad_ips_only: this.gateway.abroad_ips_only,
                    callback_limitation_only_by_vpn: this.gateway.callback_limitation_only_by_vpn,
                }, this.is_starshop)
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                    })
                    .finally(response => {
                            KTApp.unprogress(btn)
                            this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                        }
                    )
            },
            changeLogo(psp) {
                $('#gateway-change-detail-modal').modal('toggle')
                let form = $('#settings_form')
                let btn = $(`#change_logo_btn${psp}`)
                KTApp.progress(btn)
                KTUtil.scrollTop()

                let params = {
                    change_logo: $(`#change_logo-${psp}`).is(":checked"),
                    change_websiteAddress: $(`#change_websiteAddress-${psp}`).is(":checked"),
                    change_gatewayName: $(`#change_gatewayName-${psp}`).is(":checked"),
                    psp: $(event.target).data('psp'),
                    gateway_id: this.$route.params.hashid,
                }

                gatewayService.changeGatewayDetails(params, this.is_starshop).then(response => {
                    KTApp.unprogress(btn)
                    if (response.data.status == 'ok') {
                        this.toastr.success(response.data.message)

                        // this.showMsg(form, 'success', response.data.message)
                    }
                }).catch(({response}) => {
                    KTApp.unprogress(btn)
                    this.toastr.error(response.data.message)
                    // this.showMsg(form, 'danger', response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            },
            initFocusInput() {
                if (this.gateway.wage_to_sheba) {
                    document.getElementById('wage_sheba_number') && Inputmask('9999-9999-9999-9999-9999-9999').mask(document.getElementById('wage_sheba_number'))
                }
            },
            transactionsReportSetting() {
                let btn = $('#transactions_report_btn')
                KTApp.progress(btn)

                gatewayService.showPspForCommonUser(this.gateway.id, this.gateway.show_psp_report_to_user,'PF', this.is_starshop)
                    .then(this.$store.dispatch('badgeCounter/countData', this.is_starshop))
                    .catch(({response}) => {this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))})
                    .finally(response => {this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))})

                gatewayService.showStatementForCommonUser(this.gateway.id, this.gateway.show_statement_report_to_user, 'PF',  this.is_starshop)
                    .then(this.$store.dispatch('badgeCounter/countData', this.is_starshop))
                    .catch(({response}) => {this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))})
                    .finally(response => {this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))})

                KTApp.unprogress(btn)
            },
            changeStatus(form) {
                gatewayService.changeStatus(this.gateway.id, this.gateway.status, this.is_starshop)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message)
                    })
            },
            changeWage(form, btn) {
                gatewayService.changeWage(this.gateway.id, {
                    wage_type: this.gateway.wage_type,
                    wage_periodic_type: this.gateway.wage_periodic_type,
                    wage_amount: this.gateway.wage_amount,
                    wage_max_wage: this.gateway.wage_max_wage,
                    wage_min_wage: this.gateway.wage_min_wage
                }, this.is_starshop)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            changeSettlementSettings(form, btn) {
                form.validate({
                    rules: {
                        settlement_percent: {
                            required: this.gateway.partial_settlement,
                            min: 1,
                            max: 99
                        },
                        wage_sheba_number: {
                            required: this.gateway.wage_to_sheba
                        },
                    }
                })
                gatewayService.changeSettlementSettings(this.gateway.id, {
                    psp_transactions_only: this.gateway.psp_transactions_only,
                    partial_settlement: this.gateway.partial_settlement,
                    settlement_percent: this.gateway.settlement_percent,
                    wage_to_sheba: this.gateway.wage_to_sheba,
                    wage_sheba_number: this.gateway.wage_sheba_number,
                }, this.is_starshop)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message)
                    })
            },
            createTerminals(form, btn) {
            let psp_list = []
            let terminals = this.gateway.terminals
            Object.keys(terminals).forEach(function (psp) {
                if (terminals[psp]) {
                    psp_list.push(psp)
                }
            })

            if (psp_list.length === 0) {
                if (this.gateway.status == gatewayStatus.ACTIVE) {
                    psp_list.push(Object.keys(terminals)[0])
                } else {
                    alert(i18n.t('label.psp_list_cant_be_empty'))
                    KTApp.unprogress(btn)
                    return;
                }
            }
            KTApp.progress(btn)
            let params = {
                psp_list : psp_list,
                has_collective: this.has_collective,
            }
            gatewayService.createTerminal(this.gateway.id, params, this.is_starshop)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                    if (response.data.status == 'ok') {
                        this.changeStatus(form)
                        this.changeWage(form, btn)
                        this.changeSettlementSettings(form, btn)
                    }
                })
                .catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                    KTApp.unprogress(btn)
                })
        },
            terminalStatusStr(status) {
                return terminalStatusStr.get(status)
            },
            terminalStatusVariant(status) {
                return statusVariant(status)
            },
            showEditTerminalStatusForm(psp) {
                if (this.edit_terminal_status == psp) {
                    this.edit_terminal_status = null
                } else {
                    this.edit_terminal_status = psp
                }
            },
            changeTerminalStatus(psp) {
                this.gateway.shaparak_acceptors_status[psp] = Number($('#edit_terminal_status_' + psp).val())
            },
            submitTerminalStatusForm(psp) {
                if (this.change_terminal_status_processing) return;
                this.change_terminal_status_processing = true
                let btn = $('#edit_terminal_status_btn_' + psp)
                KTApp.progress(btn)
                let status = this.gateway.shaparak_acceptors_status[psp];
                let params = {
                    psp: psp,
                    status: status
                }
                gatewayService.changeTerminalStatus(this.gateway.id, params, this.is_starshop)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                        this.change_terminal_status_processing = false
                    })
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    #change_logo_btn {
        margin-right: 3%;
    }
</style>
